module.exports = __webpack_public_path__ + "static/media/dxiconsmaterial.2b9817b1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/dxiconsmaterial.woff
// module id = 7863
// module chunks = 0